const routes = [
    {
        path: '/daily/course/schedules',
        component: () => import('../pages/Index.vue'),
        meta: {
            isAuthenticated: true,
            permission: 'dailycourseschedule_index'
        },
        component_full_path: 'dailyCourseSchedule/pages/Index'
    },
    {
        path: '/daily/course/schedules/instructor',
        component: () => import('../pages/Instructor'),
        meta: {
            isAuthenticated: true,
            permission: 'dailycourseschedule_instructorcourseschedule'
        }
    },
    {
        path: '/daily/course/schedules/student',
        component: () => import('../pages/Student'),
        meta: {
            isAuthenticated: true,
            isStudent: true,
            permission: 'dailycourseschedule_studentcourseschedule'
        }
    }
];

export default routes;
